/*
 * @Author: zhangyuan zhangyuan@cheyipai.com
 * @Date: 2022-11-28 09:55:35
 * @LastEditors: zhangyuan zhangyuan@cheyipai.com
 * @LastEditTime: 2022-11-28 19:42:30
 * @FilePath: /report-template/src/util/plugin.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import jsBridge from './jsBridge.ts';

    // 点击防抖
    const debounce = (function() {
        let timer = null;
        return function (callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        };
    }());
    //函数节流
    const throttle = (function() {
        let lastTime;
        let timer;
        return function(fn, delay) {
            let time = delay || 3000;
            // 记录当前函数触发的时间
            let nowTime = Date.now();
            if (lastTime && nowTime - lastTime < time) {
                clearTimeout(timer);
            } else {
                lastTime = nowTime;
                fn.apply(this);
            }
        };
    }());
    const deviceClient = function() {
        let clientCode = 'H5';
        let u = navigator.userAgent;
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || u.indexOf('OS') > -1; //ios终端
        if (isAndroid) {
            //这个是安卓操作系统
            clientCode = 'ANDROID';
        } else if (isIOS) {
            //这个是ios操作系统
            clientCode = 'IOS';
        }
        return clientCode;
    };
    const appFunHandler = function (data, callback) {
        jsBridge.callhandler(data.methodName, data, function (data){
            callback(data)
        });
    };

export default {
    debounce,
    throttle,
    deviceClient,
    appFunHandler
}